<script>
    import {_} from '../lib/i18n';
    let now = new Date();

    export let language;
</script>

<footer class="footer">
    <div class="container">
        <div class="footer__copywrite-wrapper" style="width: 100%;">
            {#if language === 'ru-RU'}
            <a href="/" class="footer__logo-wrapper">
                <div class="footer__logo-img">
                    <img src={$_('footer.logoSmall')} />
                </div>
            </a>
            {/if}
            <div class="footer__copywrite-text" style={language !== 'ru-RU' ? 'flex: 0 0 50%;' : ''}>
                {#if language !== 'ru-RU'}
                    <a href="/" class="footer__logo-wrapper">
                        <div class="footer__logo-img">
                            <img src={$_('footer.logoSmall')} />
                        </div>
                    </a>
                    <br />
                {/if}
                <a class="footer__copywrite-link" href={`tel:${$_('footer.contactNumber')}`}>{$_('footer.contactNumberString')}</a> <br />
                © 2011-{now.getFullYear()}, {$_('footer.serviceName')} <br />
                {@html $_('footer.contactAddress')} <br />
                <div class="payment_systems">
                    {@html $_('footer.paymentIcons')}
                </div>
            </div>
            <div class="footer__links-wrapper" style={language !== 'ru-RU' ? 'flex: 0 0 50%;' : ''}>
                {#if (language === 'ru-RU')}
                    <a href="/privacy_policy" target="_blank" class="footer__link">{$_('footer.privacyRules')}</a>
                    <a href="/terms_of_use" target="_blank" class="footer__link">{$_('footer.userTerms')}</a>
                {:else}
                    <a href="/terms" target="_blank" class="footer__link">{$_('footer.userTerms')}</a>
                    <a href="/privacy-policy" target="_blank" class="footer__link">{$_('footer.privacyRules')}</a>
                    <a href="/refund-policy" target="_blank" class="footer__link">{$_('footer.refundPolicy')}</a>
                {/if}
            </div>
        </div>

        <div class="footer__disclaimer">
            {@html $_('footer.disclaimer')}
        </div>
    </div>
</footer>